import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'react-admin';
import { userLogout } from 'react-admin';

function* showMessages(action: any) {
    if (action.payload.message) {
        yield put(showNotification(action.payload.message, action.payload.status ? 'success' : 'error'));
    }

    if (action.payload.status) {
        yield put(userLogout());
    }
    if (action.requestPayload.data.completeLogout) {
        window.location.href = action.payload.data.logoutUrl + '?id_token_hint=' + action.payload.data.idToken + '&post_logout_redirect_uri=' + action.payload.data.logoutRedirectUri;
    }
}

export default function* agentSaga() {
    yield takeEvery('LOGOUT_SUCCESS', showMessages);
    yield takeEvery('LOGOUT_FAILURE', showMessages);
}
